/* ============================================================
   Pholoh PDP gallery — click the image to zoom.
   The theme's zoom (PhotoSwipe) is bound to the ".js-photoswipe__zoom"
   button, which we hide via CSS. Here we forward a click anywhere on the
   gallery image to that hidden trigger, so tapping the photo opens the
   zoom — no separate scope button needed.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.photoswipe__image');
    if (!img) return;

    var scope = img.closest('.product-main-slide') ||
                img.closest('[data-product-photos]');
    var btn = (scope && scope.querySelector('.js-photoswipe__zoom')) ||
              document.querySelector('.product-slideshow .is-selected .js-photoswipe__zoom') ||
              document.querySelector('.js-photoswipe__zoom');

    if (btn) {
      e.preventDefault();
      btn.click();
    }
  });
})();
